module.exports = __webpack_public_path__ + "img/802.e2f965ca.png";